export class Education {
    institutionName: string;
    startDate: Date;
    endDate: Date;
    city: string;
    state: string;
    levelOfEducation: string;
    fieldOfStudy: string;
    nameAttendedUnder: string;
    typeOfDegree: string;
    acquiredDegree: boolean;
    dateAwarded: string;
}